import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IChannel } from '@obvious.tech/constellation'

export const Channel = defineEntity('Channel', {
  endpoint: 'voip/api/Channel',
  schema: SNoop<IChannel>(),
})
